import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import PageTitle from 'hoc/PageTitle';
import DynamicProfilesTableContainer from 'containers/tables/DynamicProfilesTableContainer';
import { ADMINAREA_ACCESS, DYNAMIC_PROFILE_READ } from 'constants/capabilities';

const ListDynamicProfilesPage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer title="Dynamic Profiles" admin hideDatePicker />}>

        <DynamicProfilesTableContainer {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Dynamic Profiles', showGGBranding: true }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS, DYNAMIC_PROFILE_READ] }),
)(ListDynamicProfilesPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/dynamicProfiles/ListDynamicProfiles.js